import { VersionControl } from '@/interfaces/VersionControlInterface/VersionControlInterface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ConfigStore {
  versionControl: VersionControl | undefined,
}

const initialState: ConfigStore = {
  versionControl: undefined,
};
export const configSlice = createSlice({
  name: 'versionControl',
  initialState,
  reducers: {
    saveVersionControl: (state, action: PayloadAction<VersionControl | undefined>) => {
      state.versionControl = action.payload;
      if (action.payload) {
        sessionStorage.setItem('versionControl', JSON.stringify(action.payload));
      } else {
        sessionStorage.removeItem('versionControl');
      }
    },
  },
});
export const { saveVersionControl } = configSlice.actions;

export default configSlice.reducer;
